// import pacchetti
import { format } from "date-fns";
import { it } from "date-fns/locale";

// import styles
import "./Project.css";

export default function ProjectDetails({ prj, editMode, onEditClick }) {
  return (
    <div className="project-section project-details-section">

      <div className="project-description">
        <p>{prj.dettagli}</p>
      </div>

      <div className="project-info">
        <table className="project-data-table">
          <tbody>
            <tr>
              <th>Codice {prj.tipoProject === "cantiere" ? "Cantiere" : prj.tipoProject === "commessa" ? "Commessa" : "Centro di Costo"}:</th>
              <td>{prj.codice || "Non specificato"}</td>
            </tr>
            
            {prj.tipoProject === "cantiere" && (
              <tr>
                <th>Scadenza:</th>
                <td>
                  {(() => {
                    try {
                      if (prj.scadenza) {
                        // Verifica se scadenza è un oggetto Timestamp di Firestore
                        if (prj.scadenza.toDate && typeof prj.scadenza.toDate === 'function') {
                          return format(prj.scadenza.toDate(), "d MMMM yyyy", { locale: it });
                        } 
                        // Se è già una stringa in formato data (YYYY-MM-DD)
                        else if (typeof prj.scadenza === 'string' && prj.scadenza.match(/^\d{4}-\d{2}-\d{2}$/)) {
                          return format(new Date(prj.scadenza), "d MMMM yyyy", { locale: it });
                        }
                        // Se è una data JavaScript
                        else if (prj.scadenza instanceof Date) {
                          return format(prj.scadenza, "d MMMM yyyy", { locale: it });
                        }
                      }
                      return "Data non specificata";
                    } catch (error) {
                      console.error("Errore nella visualizzazione della data:", error);
                      return "Data non valida";
                    }
                  })()} 
                </td>
              </tr>
            )}
            
            {prj.tipoProject !== "centro-di-costo" && (
              <>
                <tr>
                  <th>Cliente:</th>
                  <td>{prj.cliente || "Non specificato"}</td>
                </tr>
                <tr>
                  <th>Localizzazione:</th>
                  <td>{prj.localizzazione || "Non specificata"}</td>
                </tr>
              </>
            )}
            
            {prj.tipoProject === "cantiere" && (
              <>
                <tr>
                  <th>Preventivo:</th>
                  <td>{prj.preventivo ? `€${prj.preventivo.toFixed(2)}` : "€0.00"}</td>
                </tr>
                <tr>
                  <th>Costi sostenuti:</th>
                  <td>{prj.costiSostenuti ? `€${prj.costiSostenuti.toFixed(2)}` : "€0.00"}</td>
                </tr>
                <tr>
                  <th>Avanzamento:</th>
                  <td>
                    <div className="progress-container">
                      <div 
                        className="progress-bar" 
                        style={{width: `${prj.avanzamento || 0}%`}}
                      ></div>
                      <span>{prj.avanzamento ? `${prj.avanzamento}%` : "0%"}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Margine attuale:</th>
                  <td className={prj.preventivo && prj.costiSostenuti && (prj.preventivo - prj.costiSostenuti) < 0 ? "negative-margin" : ""}>
                    {prj.preventivo && prj.costiSostenuti ? `€${(prj.preventivo - prj.costiSostenuti).toFixed(2)}` : "€0.00"}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}